import JsonSchemaUriError from "./JsonSchemaUriError.mjs";
/**
 * @public
 */
class EvaluationJsonSchemaUriError extends JsonSchemaUriError {}
export default EvaluationJsonSchemaUriError;